import { render, staticRenderFns } from "./gallery.vue?vue&type=template&id=c33b75e2&scoped=true&"
import script from "./gallery.ts?vue&type=script&lang=ts&"
export * from "./gallery.ts?vue&type=script&lang=ts&"
import style0 from "./gallery.scss?vue&type=style&index=0&id=c33b75e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33b75e2",
  null
  
)

export default component.exports